export default __webpack_public_path__ + "static/media/13.87e0ad28.jpg";